import { Button, FormControl, Grid, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DOAIconComp } from "../../components/DOAIconComp";
import { DatePickerComp, DatePickerCompProps } from "../../components/DatePickerComp";
import { MainContainer } from "../../components/MainContainerComp";
import { getDecodedShift, Shifts } from "../../utils/decodeShift";
import { IJob } from "./DispatchAvailabilityListReportData";
import { asteriskStyle, buttonContainerStyle, buttonStyle, GridItemStyle, selectStyle, descriptionStyle } from "./styled";

interface IDispatchAvailabilityListReportProps {
  datePickerCompProps: DatePickerCompProps;
  dispatchType: string;
  selectedJob: IJob;
  jobs: IJob[];
  disabledView: boolean;
  handleSubmit: () => void;
  handleShiftChange: (event: SelectChangeEvent<string>) => void;
  handleJobChange: (event: SelectChangeEvent<string>) => void;
}

export const DispatchAvailabilityListReport: React.FC<IDispatchAvailabilityListReportProps> = ({
  datePickerCompProps,
  dispatchType,
  selectedJob,
  jobs,
  disabledView,
  handleSubmit,
  handleShiftChange,
  handleJobChange,
}) => {
  return (
    <MainContainer>
      <DOAIconComp />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Typography sx={descriptionStyle}>
          The Dispatch Availability List will display rated employees for a given date, dispatch and job.
        </Typography>
        <DatePickerComp {...datePickerCompProps} />
        <Grid spacing={2} container sx={{ justifyContent: 'center' }}>
          <Grid item xs={12} md={4} sx={GridItemStyle}>
            <Typography>Dispatch Shift <Typography component={"span"} sx={asteriskStyle}>*</Typography></Typography>
            <FormControl fullWidth>
              <Select
                sx={selectStyle}
                fullWidth
                value={dispatchType}
                onChange={handleShiftChange}
              >
                {Shifts.map((shift) => (
                  <MenuItem
                    key={shift}
                    value={shift}
                  >
                    {getDecodedShift(shift)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {selectedJob && <Grid spacing={2} container sx={{ justifyContent: 'center' }}>
          <Grid item xs={12} md={4} sx={GridItemStyle}>
            <Typography>Job <Typography component={"span"} sx={asteriskStyle}>*</Typography></Typography>
            <FormControl fullWidth>
              <Select
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 250,
                    },
                  },
                }}
                sx={selectStyle}
                fullWidth
                value={`${selectedJob.jobId}`}
                onChange={handleJobChange}
              >
                {jobs.map((j) => (
                  <MenuItem
                    key={j.jobId}
                    value={j.jobId}
                  >
                    {j.jobDescription}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>}

        <Grid sx={{ justifyContent: 'center' }} container>
          <Grid sx={buttonContainerStyle} item xs={12} md={8}>
            <Button sx={buttonStyle} onClick={handleSubmit} disabled={disabledView} variant="contained" size="medium">
              View Report
            </Button>
          </Grid>
        </Grid>
      </LocalizationProvider>
    </MainContainer>
  )
}